import { formMachine } from '../../../xform';
import accountNumberConfig from './accountNumberConfig';
import nicknameConfig from './nicknameConfig';
import routingNumberConfig from './routingNumberConfig';
const createBankFormMachine = (apiMachineRef) => formMachine.withContext({
    // DO NOT CHANGE: the order of these configs must mirror the position of the inputs in the UI for the error focus to work
    fieldConfigs: [
        routingNumberConfig(apiMachineRef),
        accountNumberConfig(),
        nicknameConfig()
    ]
});
export default createBankFormMachine;
